import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import CompanyForm from "../companyForm/companyForm";

export default class AddCompany extends React.Component {
    render() {
        return (
            <AddItem
                class="add-company"
                header={i18n.t("dictionaries.companies.actions.addCompany.header")}
                content={<CompanyForm isUpdate={false}/>}
            />
        );
    }
}